import { HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Authenticate } from '../models/auth/authenticate';
import { KeyValuePair } from '../models/interfaces/key-value-pair';
import { MemoryService } from './memory.service';

export class DefaultHttpService {
    /** URL pour le webService */
    public baseUrl = environment.serverUrl;

    /**
     * Constructeur
     */
    constructor(public memoryService: MemoryService) {}

    /**
     * Récupère l'id de l'organisation sélectionnée.
     */
    public get organizationId(): string {
        return this.memoryService.getSelectedOrganization()?.id;
    }

    /**
     * Récupère l'id de la vue selectionnée
     */
    public get viewId(): number {
        return this.memoryService.getSelectedView()?.id;
    }

    /**
     * Récupère les information de l'utilisateur
     */
    public get connectedUser(): Authenticate {
        return this.memoryService.getConnectedUser();
    }

    public getDefaultHttpOptions(): {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
    } {
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return httpOptions;
    }

    public getParameterizedHttpOptions(
        parameters: KeyValuePair[],
        responseType: string = null
    ): {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
    } {
        let params = new HttpParams();

        parameters.forEach((x) => {
            params = params.set(x.key, x.value);
        });

        let httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            params: params,
        };

        if (responseType !== null) {
            httpOptions['responseType'] = responseType;
        }

        return httpOptions;
    }

    public getCustomResponseTypeHttpOptions(responseType: string = null): {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
    } {
        let httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            params: new HttpParams(),
        };

        if (responseType !== null) {
            httpOptions['responseType'] = responseType;
        }

        return httpOptions;
    }

    public getMultipartContentType(): {
        headers?: HttpHeaders | { [header: string]: string | string[] };
        params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
    } {
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' }) };
        return httpOptions;
    }
}
